import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import { TextAreaInput } from '../../text-area/TextAreaInput';
import { DATA_FORM_INPUT } from '../../common/data';

export type TextAreaProps = VFFieldProps<
  React.ComponentProps<typeof TextAreaInput>
>;

export const TextArea = React.forwardRef<HTMLInputElement, TextAreaProps>(
  (
    {
      name,
      inlineValidation,
      validate,
      className,
      inputClassName,
      contentClassName,
      label,
      onChange: customOnChange,
      required,
      disabled,
      readOnly,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, name, ...nother },
            meta,
          }: FieldRenderProps<string>) => {
            const handleChange = React.useCallback(
              (e: React.ChangeEvent<HTMLTextAreaElement>) => {
                let realVal: string | undefined = e.target.value;
                if (realVal === '') {
                  realVal = undefined;
                }
                const rv = { target: { name, value: realVal } };
                customOnChange ? customOnChange(realVal as any) : onChange?.(rv);
              },
              [customOnChange, onChange, name]
            );
            return (
              <TextAreaInput
                {...DATA_FORM_INPUT(name)}
                className={inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                {...other}
                disabled={disabled || meta.submitting}
                readOnly={readOnly}
                onChange={handleChange}
                value={value}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
